if (!customElements.get('localization-form')) {

    class LocalizationForm extends HTMLElement {
        constructor() {
            super();
            this.elements = {
                input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
                button: this.querySelector('button'),
                panel: this.querySelector('ul'),
            };
            this.elements.button.addEventListener('click', this.openSelector.bind(this));
            this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
            this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

            this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));

        }

        displayLocation(){
        }

        hidePanel() {
            this.elements.button.setAttribute('aria-expanded', 'false');
            this.elements.panel.setAttribute('hidden', true);
        }

        onContainerKeyUp(event) {
            if (event.code.toUpperCase() !== 'ESCAPE') return;

            this.hidePanel();
            this.elements.button.focus();
        }

        onItemClick(event) {
            event.preventDefault();
            const form = this.querySelector('form');
            this.elements.input.value = event.currentTarget.dataset.value;

            this.hidePanel(); // Hide immediately to prevent visual breakage during reload

            // UX Feedback: Show loading text while Shopify natively reloads the page
            const mainSpan = this.elements.button.querySelector('span');
            if (mainSpan) {
                mainSpan.innerHTML = 'Actualizando...';
                mainSpan.style.opacity = '0.6';
            }

            if (form) form.submit();

        }

        openSelector(event) {
            this.elements.button.focus();
            this.elements.panel.toggleAttribute('hidden');
            this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());

            // VERTICAL COLLISION: Check available space above and below
            const buttonRect = this.elements.button.getBoundingClientRect();
            const spaceBelow = window.innerHeight - buttonRect.bottom;
            const spaceAbove = buttonRect.top;

            // Preferred max height is 400px, but we adapt if window is small
            if (spaceBelow < 350 && spaceAbove > spaceBelow) {
                // Better to place it above
                this.elements.panel.classList.add('place-above');
                this.elements.panel.classList.remove('place-below');
                this.elements.panel.style.maxHeight = (spaceAbove - 15) + 'px';
            } else {
                // Place it below
                this.elements.panel.classList.remove('place-above');
                this.elements.panel.classList.add('place-below');
                this.elements.panel.style.maxHeight = (spaceBelow - 15 > 400 ? 400 : spaceBelow - 15) + 'px';
            }

            // HORIZONTAL COLLISION: Bulletproof check based on screen half
            if (buttonRect.left > window.innerWidth / 2) {
                this.elements.panel.classList.add('place-right-edge');
            } else {
                this.elements.panel.classList.remove('place-right-edge');
            }
        }

        closeSelector(event) {
            const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
            
            // Retrasar el cierre 200ms para asegurar que Safari/iOS permita al evento 'click' del enlace registrarse antes de esconderlo.
            setTimeout(() => {
                if (event.relatedTarget === null || shouldClose) {
                    // Solo cierra si no dimos clic activamente interno 
                    // (el click ya debió disparar onItemClick y forzar hidePanel anyway)
                    if (!this.elements.panel.hasAttribute('hidden')) {
                        this.hidePanel();
                    }
                }
            }, 200);

            // Eliminado el remove() local de clases de posición para evitar saltos bruscos (glitches)
        }
    }

    customElements.define('localization-form', LocalizationForm);
    
}